// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { h } from 'vue'
import { createVuetify } from 'vuetify'
import { aliases, mdi as mdiIconSet } from 'vuetify/iconsets/mdi'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VTimePicker } from 'vuetify/components'
import MdiHumanMaleBoardPollIcon from '@/components/icons/MdiHumanMaleBoardPollIcon.vue'

const TRAINER_POLL_ICON_NAMES = new Set([
  'mdi-human-male-board-poll',
  'mdi-human-male-board',
  'human-male-board-poll',
  'human-male-board',
])

function parseIconSize(size) {
  if (typeof size === 'number' && !Number.isNaN(size)) return size
  if (typeof size === 'string') {
    const parsed = parseInt(size, 10)
    if (!Number.isNaN(parsed)) return parsed
  }
  return 24
}

const mdi = {
  component: (props) => {
    if (TRAINER_POLL_ICON_NAMES.has(props.icon)) {
      return h(MdiHumanMaleBoardPollIcon, {
        size: parseIconSize(props.size),
        iconClass: props.class,
      })
    }
    return mdiIconSet.component(props)
  },
}

export default createVuetify(
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  {
    components: {
      VDateInput,
      VTimePicker,
    },
    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: { mdi },
    },
    theme: {
      defaultTheme: 'light',
      themes: {
        light: {
          colors: {
            primary: '#3f51b5',
            secondary: '#8A8D93',
            error: '#FF5252',
            info: '#2196F3',
            success: '#4CAF50',
            warning: '#FB8C00',
          },
        },
        dark: {
          colors: {
            primary: '#3f51b5',
            secondary: '#8A8D93',
            error: '#FF5252',
            info: '#2196F3',
            success: '#4CAF50',
            warning: '#FB8C00',
          },
        },
      },
    },
  }
)
